import React from "react"

 export const CourseContext = React.createContext();

 export const EnqueryBookdata = React.createContext();


// export default CourseContext